<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon"
    [tooltipText]="'Empleados importados desde a3Innuva Nómina con tipo \'trabajador\'. No se muestran profesionales independientes. Solo se incluyen empleados activos, con posición definida y correo profesional. Si falta algún dato, no se importarán o se inhabilitarán.'">
    <dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
      (onEditorPreparing)="onEditorPreparing($event)" (onExporting)="onExporting($event)"
      (onSelectionChanged)="updateSelectedRows($event)">

      <!-- Definición de las columnas -->
      <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>
      <dxi-column dataField="nif" caption="NIF" alignment="center"></dxi-column>
      <dxi-column dataField="mail" caption="Nombre de usuario"></dxi-column>
      <dxi-column *ngIf="livesLicence" dataField="section.name" caption="Sección" alignment="center"></dxi-column>
      <!--  <dxi-column dataField="role" caption="Rol" alignment="center" [calculateCellValue]="getRoleName">
      </dxi-column> -->
      <dxi-column dataField="name" caption="Nombre"></dxi-column>
      <dxi-column dataField="surnames" caption="Apellidos"></dxi-column>
      <dxi-column dataField="company.name" caption="Empresa"></dxi-column>
      <dxi-column dataField="enabled" caption="Acceso App" alignment="center" sortOrder="desc"
        [calculateCellValue]="transformBooleanToYesNo"></dxi-column>
      <dxi-column *ngIf="conectiaLicence" dataField="dropDate" caption="Fecha de baja" alignment="center"
        [calculateDisplayValue]="getFormattedDate">></dxi-column>
      <!-- Templates -->
      <ng-container *ngIf="isCrud">
        <dxi-column *ngIf="!exporting" dataField="user1" caption="Acciones" [allowFiltering]="false"
          [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"
          [allowExporting]="false"></dxi-column>
        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
          <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onClickEdit(data.value)">
            <i class="material-icons">edit</i>
          </button>
          <button rel="tooltip" type="button" class="btn btn-success btn-action btn-blue"
            (click)="sendInvite(data.data)">
            <i class="material-icons">mail</i>
          </button>
          <!-- <button rel="tooltip" type="button" class="btn btn-danger btn-action"
            (click)="onClickDelete(data.key, data.rowIndex)">
            <i class="material-icons">close</i>
          </button> -->
        </ng-container>
      </ng-container>

      <!-- Añadir nuevos -->

      <dxo-export [enabled]="true" [fileName]="'Listado_Empleados'"></dxo-export>

      <div *dxTemplate="let data of 'addNew'">
        <button *ngIf="!conectiaLicence" class="btn btn-success btn-sm btn-accept btn-blue ml-2"
          style="padding-inline: 10px;" (click)="onClickAdd()">
          <i class="material-icons icon-centered mr-2" style=" scale: 1.2; ">add</i>
          <span class="d-none d-sm-inline-block" style=" scale: 1.05; ">Nuevo</span>
        </button>
        <button *ngIf="!conectiaLicence" class="btn btn-success btn-sm btn-accept btn-blue ml-2"
          style="padding-inline: 10px;" (click)="onClickImport()">
          <i class="material-icons icon-centered mr-2" style=" scale: 1.2; ">add</i>
          <span class="d-none d-sm-inline-block" style=" scale: 1.05; ">Importar</span>
        </button>
        <button *ngIf="selectedRows.length > 0" class="btn btn-success btn-sm btn-accept btn-blue ml-2"
          (click)="onClickInvite()">
          <i class="material-icons icon-centered mr-2">mail</i>
          <span class="d-none d-sm-inline-block">Invitar Usuarios</span>
        </button>

      </div>

    </dx-data-grid>

    <dx-popup [(visible)]="showProgressPopup" [showTitle]="false" [width]="400" [height]="200" [dragEnabled]="false" Add
      commentMore actions [closeOnOutsideClick]="false" [showCloseButton]="false" title="Enviando invitaciones...">
      <div class="p-3">
        <div class="mb-5 text-center">
          <h3>Invitando empleados</h3>
        </div>
        <div class="mb-2 text-center">
          {{ currentInviteIndex + 1 }} de {{ totalInvites }}
        </div>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width.%]="(currentInviteIndex / totalInvites) * 100"
            aria-valuemin="0" [attr.aria-valuenow]="(currentInviteIndex / totalInvites) * 100"
            [attr.aria-valuemax]="100">
          </div>
        </div>
      </div>
    </dx-popup>

  </app-generic-panel>

  <br>
</app-generic-container>